import { useSelect } from '@wordpress/data';
import { registerPlugin } from '@wordpress/plugins';
import { PluginPostStatusInfo } from '@wordpress/editor';
import { Button } from '@wordpress/components';
import { useState } from '@wordpress/element';
import { RulesModal } from '../modal-conditions/modal';
import { __ } from '@wordpress/i18n';
import { useEntityProp } from '@wordpress/core-data';

const Component = ( props ) => {
	const { postType, postId } = useSelect( ( select ) => {
		return {
			postType: select( 'core/editor' ).getCurrentPostType(),
			postId: select( 'core/editor' ).getCurrentPostId(),
		};
	}, [] );

	const [ isModalOpen, setModalOpen ] = useState( false );
	const [ options ] = useEntityProp( 'root', 'site', 'formello' );

	const allowed = [ 'popper' ];

	if ( ! allowed.includes( postType ) ) {
		return false;
	}

	const closeModal = () => setModalOpen( false );

	return (
		<PluginPostStatusInfo
			title={ __( 'Display Rules', 'popper' ) }
			icon={ () => '' }
			opened={ true }
			name="popper-display"
		>
			<Button
				variant="primary"
				onClick={ () => {
					setModalOpen( true );
				} }
				disabled={
					'formello_form' === postType &&
					! options?.enabled_addons.includes( 'inserter' )
				}
				icon="visibility"
				className="popper-display-button"
			>
				{ __( 'Display Rules', 'popper' ) }
			</Button>

			{ isModalOpen && (
				<RulesModal
					onRequestClose={ closeModal }
					postId={ postId }
					{ ...props }
				/>
			) }
		</PluginPostStatusInfo>
	);
};

registerPlugin( 'popper-display', {
	render: Component,
} );
